import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const ModuleList = lazy(() => import('../../pages/settings/module/ModuleList'));
const UserRoleList = lazy(() => import('../../pages/settings/user_role/UserRoleList'));
const ActionList = lazy(() => import('../../pages/settings/action/ActionList'));
const AddAction = lazy(() => import('../../pages/settings/action/AddAction'));
const UpdateAction = lazy(() => import('../../pages/settings/action/UpdateAction'));
const Permission = lazy(() => import('../../pages/settings/permission/Permission'));

export const SettingsImport = {
    RoutesMap,
    ModuleList,
    UserRoleList,
    ActionList,
    AddAction,
    UpdateAction,
    Permission,
}